'use client';

import React from 'react';

import { Heading, Body } from '@depop/web-thrift-ui/Typography';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import styles from '../styles.module.css';

import { useCurrentLanguage } from '@/modules/language/useCurrentLanguage';
import { useProductsSearchWithFallback } from '@/modules/search/useProductsSearchWithFallback';
import { formatNumberWithMetricPrefix } from '@/modules/text/helpers';

type Props = {
  EmptySearch?: React.ReactNode;
};

export function HeaderText({ EmptySearch }: Props) {
  const t = useTranslations('search');
  const { language } = useCurrentLanguage();
  const params = useSearchParams();
  const searchInput = params.get('q') || '';

  const { data, isFetching } = useProductsSearchWithFallback();

  const count = data?.pages[0]?.data.meta.total_count;
  const formattedCount = formatNumberWithMetricPrefix(count || 0, language);

  return !!searchInput ? (
    <Heading variant="lg" className={styles.searchHeaderText}>
      <span className={styles.searchInput}>&#8220;{searchInput}&#8221;</span>
      <Body
        variant="sm-regular"
        as="span"
        className={styles.searchQuerySecondary}
      >
        {isFetching
          ? t('LoadingResultsV2')
          : `(${formattedCount} ${t('Results')})`}
      </Body>
    </Heading>
  ) : (
    <>{EmptySearch}</>
  );
}
